const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const createAdvancedSearchAgentMachine = ({
  qmsToolApiUrl,
  authentication,
  periodSelectedEventType,
  rangeSelectedEventType,
  clearedEventType,
  applyEventType,
  errorEventType,
  year,
  month,
}) => {
  return createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QEMIDdkDsDGkAEsYyATtgBYDEAwgDICiAggEoDaADALqKgAOA9rACWAF0F9M3EAA9EAdgBMbAHQBWeSoCcAZgCMWlWy1aAbDoA0IAJ6IAtPN1KALFrYaAHC5c6Dj4wF8-C1QMHHxCEnIKBgAFaJoATXYuJBB+IVFxSRkEeR0NJQ1ZFX09LQ1FNmNHC2sEHTZ1JQ8NY2NZDR1ZWT0VAKD0LFwIAiJSMiVBCAAbMAokyTSRMQkU7JtC1VkXdS0PR3lHDRrbFRU3AsLfN3sVfdM+kGDBsNHyJTBiYj5iCiY6ABUmIlOAsBEtMqtED0Cm4VN1HIdtEY3G5jggbGp5KoEVoEY49I5ujoHk9QsNwmMlFM+KhBJgoFEAOJ0ABy-yUDAAIgA1Bgsqh0TkAfQAyowmFQABJCmgAeS5AEkWYyhXQmExZawQSlFhkVqBsvI3MYlGwGpiDvJ5MZrbI0TYylircadG5fC42lsSQMySMIuNqbT6UzWeyubz+YLReKpULOQx-gwZfLOYL5jqwXqsrYylolJ0tAp1GcXeYrLZ7HnTq03IZZGxbiitN6QkM-ZTAxA6Qz07xM8tswgHN5dl0imPHA2VPbvLJTbnFCY8mxus3Ao8fW2KW9O5AKABVaLx-50IUAIXFaqF-1lAGlWb3Uv2IQbbMYUUpC24NB1dupOtO5Z1MYKhKO0RryIUIFtMUbgts85KvAGNIQJASjkGA2AANZ4Mg2CiGgYB4MIyAAEZzNqfbpAOkLojon7Wma+JXN+VS+GiuT0Z0CJwhoZoaAiOj+OupJbkhVIoWhGHYbh+GCIRxFkXMOjJFR4L6tIiC7I42JuHk7QdEUtbGBxOhcbIPHtPxgnCf0rYvP6EmoGhPAfGIEAUAAsrKbLSmK9BUCenKPrqNGvuiiigd49TdHxkGugJaIqHoTRbHCtYrs4shwSJm4OR2kkQEornEO5FDxOK0YBUFIXPhpaw6PYSgHCB8hGWwOi+HkaLviaRqHG4RTGLshTwb627Ic5RUlWV3IKnQADqQpMHyzJCrK0T-AqPkirV1EvppwE6UYBZ6fog02tUQFGPkphQeBiLaGNYmObuRXEFgMAUHNi1CtEarbcKG1bTte3qYOnT0fYBllBoyUGCZQHFPkKjGB0k4dcNXSOM9+U7oVSgffSswiomTD-HGCanv5dCBWmlFPvt9WIGc9GFAcbD4l06iDWiJhYpow2VIYk6nDldkIe2+NTYTn2zKywrHtTdDVfTqmM+DtGaMo3SVHpRYGK6SU2tiqPZdxXQdAE66YHwqHwCkol42QoJM4ONhbCaX4-no1zJUU9r1qB9Z8e0ChqLc8i44hjmTDMrua+FDpmvONqdQ0eS5Fo9qmOcuymMNQkooNUe5fZMeUh8XzEAnWa0biJol44BgGOUk6dfaqMmsNOzOPifFW2XksTU5Xb0rXYWHRieZWpo3geDByP2pOJqdVnWUlMa0dS5NqEQBPB1rDs+bJSuy7xd+V21Mln5VAc2Wc4Wzc40P43iW96FkJhOF4QRREkaRA+zMcjmXaD0W4mhvwNDRL7JQ74iRXGtCiFo28R4fxmnbIBg44ROD4viMy7guh6QbGiZu5wzj2CbIUNg4sNzlx3qPNCRMYBYNos3fI5RdA-kcINPSBxSFnFUNcQsnMGx8U0NbPwQA */
      id: "advanced search",

      predictableActionArguments: true,

      context: {
        activeTab: "period",
        month: month || null,
        year: year || null,
        startDate: null,
        endDate: null,
        qmsToolApiUrl: qmsToolApiUrl,
        authentication: authentication,
        periodSelectedEventType: periodSelectedEventType,
        rangeSelectedEventType: rangeSelectedEventType,
        clearedEventType: clearedEventType,
        applyEventType: applyEventType,
        errorEventType: errorEventType,
        changesHappened: year ? true : false,
      },

      states: {
        idle: {
          always: {
            target: "loading",
            actions: ["spawnFetchAgent"],
          },
        },

        error: {
          on: {
            RETRY: "loading",
          },

          entry: "saveError",
        },

        loading: {
          entry: ["sendLoadRequestToFetchAgent"],

          always: {
            target: "loaded",
            cond: "allDataLoaded",
            actions: ["unsetDataLoaded", "updateLastRefreshedTimestamp"],
          },

          on: {
            "AGENT.ADVANCED_SEARCH_LOADING_ERROR": {
              target: "error",
              actions: ["unsetDataLoaded", "sendErrorEventTypeToParent"],
            },

            "AGENT.ADVANCED_SEARCH_DATA_LOADED": {
              target: "loading",
              internal: true,
              actions: [
                "saveAdvancedSearchData",
                "setAdvancedSearchDataLoaded",
              ],
            },
          },
        },

        loaded: {
          initial: "check active tab",

          states: {
            "check active tab": {
              always: [
                {
                  target: "period",
                  cond: "periodOptionsActive",
                },
                {
                  target: "range",
                  cond: "rangeOptionsActive",
                },
              ],
            },

            period: {
              on: {
                MONTH_SELECTED: {
                  target: "period",
                  internal: true,
                  actions: ["saveMonth", "resetRangeOptions", "flagChanges"],
                  cond: "validMonth",
                },

                YEAR_SELECTED: {
                  target: "period",
                  internal: true,
                  actions: ["saveYear", "resetRangeOptions", "flagChanges"],
                  cond: "validYear",
                },

                VIEW_RANGE_OPTIONS: {
                  target: "range",
                  actions: "setRangeOptionsAsActiveTab",
                },
              },
            },

            range: {
              on: {
                VIEW_PERIOD_OPTIONS: {
                  target: "period",
                  actions: "setPeriodOptionsAsActiveTab",
                },

                START_DATE_SELECTED: {
                  target: "range",
                  internal: true,
                  actions: [
                    "saveStartDate",
                    "resetPeriodOptions",
                    "flagChanges",
                  ],
                },

                END_DATE_SELECTED: {
                  target: "range",
                  internal: true,
                  actions: ["saveEndDate", "resetPeriodOptions", "flagChanges"],
                },
              },
            },
          },

          on: {
            UPDATE_BEARER_TOKEN: {
              target: "loaded",
              internal: true,
              cond: "validToken",
              actions: [
                "sendUpdateBearerTokenEventTypeToFetchAgent",
                "saveToken",
              ],
            },
          },
        },
      },

      initial: "idle",

      on: {
        CLEAR: {
          target: ".loaded.check active tab",
          actions: [
            "resetPeriodOptions",
            "resetRangeOptions",
            "unflagChanges",
            "sendClearedToParent",
          ],
          cond: "changesHappened",
        },

        APPLY: {
          target: "#advanced search",
          internal: true,
          cond: "validPeriodOrRangeSelected",
          actions: "sendApplyEventToParent",
        },
      },
    },
    { actions, guards, services },
  );
};

export { createAdvancedSearchAgentMachine };
